import React from 'react';
import { Button, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Instruments } from '@/shared/i18n';

interface InstrumentNotAddedCardProps {
  imageSrc: string;
  title: string;
  onAdd: () => void;
  dict: Instruments;
}

const InstrumentNotAddedCard: React.FC<InstrumentNotAddedCardProps> = ({
  imageSrc,
  title,
  onAdd,
  dict,
}) => (
  <div className="bg-paper border border-action-divider rounded-lg w-full h-full">
    <div className="flex flex-col gap-1 justify-center w-full h-full">
      <img
        src={imageSrc}
        alt={`${title} instrument`}
        className="w-[48px] h-[48px] md:h-[72px] md:w-[72px] mx-auto mt-2 md:mt-0"
      />
      <Typography variant="s2" component="p" className="mt-2 w-full text-center mb-auto">
        {title}
      </Typography>
      <Button
        size="medium"
        variant="text"
        color="primary"
        className="w-full py-2 md:py-4"
        onClick={onAdd}
      >
        <Add />
        <Typography variant="button-l">{dict.instruments.add_instrument}</Typography>
      </Button>
    </div>
  </div>
);

export default InstrumentNotAddedCard;
